<template>
  <div class="page-wrap">
    <el-dialog :close-on-click-modal="false" title="应用管理" :visible.sync="dialogVisible" width="1014px">
      <div class="modal-body" v-if="modalType === 1">
        <div class="filter">
          <!-- <el-form :inline="true" :model="formSearch" ref="formSearch" class="demo-form-inline">
            <div style="display: flex">
              <el-form-item label="">
                <el-select
                  v-model="formSearch.searchType"
                  style="width: 300px"
                  filterable
                  placeholder="全部应用"
                  popper-class="BI-select BI-select-product"
                >
                  <el-option label="全部应用" value="ALL"></el-option>
                  <el-option label="我创建的应用" value="CREATE_ONLY"></el-option>
                  <el-option label="共享的应用" value="SHARED_ONLY"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-input placeholder="请输入应用名称或应用id" v-model="formSearch.search" />
              </el-form-item>
              <el-form-item style="flex: 1; text-align: left">
                <el-button type="primary" @click="handlerSearch">查询</el-button>
                <el-button type="primary" @click="handlerReset">重置</el-button>
              </el-form-item>
            </div>
          </el-form> -->
        </div>
        <div class="table-wrap">
          <el-table :data="proTableList" style="width: 100%" max-height="500px">
            <!-- <el-table-column prop="type" label="应用" width="100">
              <template slot-scope="scope">
                <img class="product-icon" :src="scope.row.icon_url" />
              </template>
            </el-table-column> -->
            <el-table-column prop="app_id" label="应用ID">
              <template slot-scope="scope">
                <span>{{ scope.row.os_type === "ANDROID" ? scope.row.app_id : "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="app_name" label="应用名称"> </el-table-column>
            <el-table-column prop="package_name" label="应用包名"> </el-table-column>
            <!-- <el-table-column prop="version" width="170" label="版本信息"> </el-table-column> -->
            <el-table-column prop="operate" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="handlerChoose(scope.row)">使用该应用包</el-button>
                <el-button type="text" v-if="scope.row.os_type === 'ANDROID'" @click="jumpSubpackProduct(scope.row)">选择分包</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="footer-wrap">
        </span>
      </div>
      <div class="modal-body" v-if="modalType === 2">
        <div class="title" @click="backProduct">应用管理 / {{ productData.app_name }}</div>
        <div class="filter">
          <el-form :inline="true" :model="formSearch" ref="formSearch" class="demo-form-inline">
            <div style="display: flex">
              <el-form-item label="">
                <el-input placeholder="请输入渠道号" v-model="formSearch.searchKey" />
              </el-form-item>
              <el-form-item style="flex: 1; text-align: left">
                <el-button type="primary" @click="handlerSearchSub">查询</el-button>
                <el-button @click="handlerResetSub">重置</el-button>
                <el-button @click="handlerRefrsh" :loading="loading">同步数据</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="table-wrap">
          <el-table :data="subpackList" style="width: 100%" max-height="500px">
            <el-table-column prop="channelId" label="渠道号" width="100"> </el-table-column>
            <el-table-column prop="downloadUrl" label="下载链接"> </el-table-column>
            <el-table-column prop="versionName" width="80" label="版本信息"> </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="chooseSubpack(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="footer-wrap">
          <self-pagination
            :total="subpackPageData.total"
            :pageSize="subpackPageData.size"
            :currentPage="subpackPageData.page"
            @getCurrentPage="changeSubpackPage"
            @handleSizeChange="changePageSize"
            ref="tabelPagination"
          ></self-pagination>
          <div></div>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getConvertProductList, getExtendPackageList, syncExtendPackageList } from "@/api/promotion.js";
export default {
  data() {
    return {
      dialogVisible: false,
      proTableList: [],
      formSearch: {
        searchType: "ALL",
        search: "",
        searchKey: "",
      },
      productPageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      subpackPageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      subpackList: [],
      modalType: 1, // 1 应用 2 分包
      productData: {},
      adCount: "",
      loading: false,
    };
  },

  computed: {},

  watch: {},

  mounted() {},

  methods: {
    async showModal(adCount) {
      this.adCount = adCount;
      await this.getList();
      this.modalType = 1;
      this.dialogVisible = true;
    },
    getList() {
      getConvertProductList({
        advertiserId: this.adCount,
        // page: this.productPageData.page,
        // pageSize: this.productPageData.size,
        // searchKey: this.formSearch.search,
        // searchType: this.formSearch.searchType,
      }).then((res) => {
        this.proTableList = res.data.list;
      });
    },
    getSubList() {
      getExtendPackageList({
        advertiserId: this.adCount,
        packageId: this.productData.package_id,
        page: this.subpackPageData.page,
        pageSize: this.subpackPageData.size,
        searchKey: this.formSearch.searchKey,
      }).then((res) => {
        this.subpackList = res.data.list;
        this.subpackPageData.total = res.data.total;
      });
    },
    changeProductPage(page) {
      this.productPageData.page = page;
      this.getList();
    },
    changeSubpackPage(page) {
      this.subpackPageData.page = page;
      this.getSubList();
    },
    changePageSize(size) {
      this.subpackPageData.page = 1;
      this.subpackPageData.size = size;
      this.getSubList();
    },
    handlerSearch() {
      this.productPageData.page = 1;
      this.getList();
    },
    handlerSearchSub() {
      this.subpackPageData.page = 1;
      this.getSubList();
    },
    handlerReset() {
      this.formSearch.searchType = "ALL";
      this.formSearch.search = "";
      this.productPageData.page = 1;
      this.getList();
    },
    handlerResetSub() {
      this.formSearch.searchKey = "";
      this.subpackPageData.page = 1;
      this.getSubList();
    },
    handlerChoose(row) {
      this.$emit("chooseCallback", row);
      this.dialogVisible = false;
    },
    jumpSubpackProduct(row) {
      this.productData = row;
      this.getSubList();
      this.modalType = 2;
    },
    chooseSubpack(data) {
      this.productData.download_url = data.download_url || data.downloadUrl;
      this.productData.channel_id = data.channel_id || data.channelId;
      this.$emit("chooseCallback", this.productData);
      this.dialogVisible = false;
    },
    handlerRefrsh() {
      this.loading = true;
      syncExtendPackageList({
        advertiserId: this.adCount,
        packageId: this.productData.package_id,
      })
        .then((res) => {
          if (res.code === "0000") {
            this.handlerResetSub();
            this.loading = false;

            this.$message.success("同步成功");
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    backProduct() {
      this.modalType = 1;
    },
  },
};
</script>

<style lang="less" scoped>
.modal-body {
  padding-bottom: 30px;
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    cursor: pointer;
    margin-bottom: 8px;
    width: 350px;
  }
  .product-icon {
    width: 50px;
  }
}
</style>
